import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FieldErrors } from "src/api/types";
import { ClauseBlock, ClauseForm } from "src/clauseBlock/ClauseBlock";
import { Junctions } from "src/clients/flow-api";
import {
  InboundWebhookConnectionConfigInputs,
  ConnectionCreationFieldError,
} from "src/connections/types";
import { convertFieldErrorsConnectToFe } from "src/utils/FieldErrorUtils";

type Props = {
  resourceIndex: number;
  fieldErrors?: ConnectionCreationFieldError[];
};

export const InboundWebhookActivationConditionForm: React.FC<Props> = ({
  resourceIndex,
  fieldErrors,
}) => {
  const { control, setValue } =
    useFormContext<InboundWebhookConnectionConfigInputs>();

  const key = `resourceConfigs.${resourceIndex}.activation` as const;

  const handleChange = (value: ClauseForm) => {
    setValue(key, { clauses: value.clauses, junction: value.junction });
  };

  const convertedFieldErrors: FieldErrors | undefined = fieldErrors
    ? convertFieldErrorsConnectToFe(fieldErrors)
    : undefined;

  return (
    <Controller
      control={control}
      name={key}
      render={({ field }) => (
        <ClauseBlock
          clauses={field.value?.clauses || []}
          fieldErrors={convertedFieldErrors}
          fieldPlaceholder="e.g. webhook.body.status"
          immutable={false}
          junction={field.value?.junction || Junctions.AND}
          junctionWidth="w-16"
          prefixClassName="w-20"
          valuePlaceholder='e.g. "Successful"'
          allowDeletingAllClauses
          onChange={handleChange}
        />
      )}
    />
  );
};
